import { c as _c } from "react/compiler-runtime";
import { Checkbox, Form, InlineAlert } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useSession from '@/hooks/use-session';
type FormData = {
  versionDescription: string;
  skipValidation: boolean;
};
type VersionFormProps = {
  action: 'draft' | 'deploy' | 'publish';
  hideAlert?: boolean;
  isProduction?: boolean;
  graphHasErrors: boolean;
  onSubmit: (formData: FormData) => void;
};
const VersionForm = t0 => {
  const $ = _c(43);
  const {
    action,
    hideAlert: t1,
    isProduction: t2,
    graphHasErrors,
    onSubmit
  } = t0;
  const hideAlert = t1 === undefined ? false : t1;
  const isProduction = t2 === undefined ? false : t2;
  const {
    t
  } = useTranslation("playbook-builder");
  const {
    data: t3
  } = useSession();
  const {
    user
  } = t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      defaultValues: {
        versionDescription: "",
        skipValidation: false
      }
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const formMethods = useForm(t4);
  const {
    register,
    formState: t5
  } = formMethods;
  const {
    errors
  } = t5;
  let t6;
  if ($[1] !== action || $[2] !== isProduction) {
    t6 = () => {
      if (action === "draft") {
        return "info";
      }
      if (action === "deploy") {
        return "warning";
      }
      if (isProduction) {
        return "error";
      }
      return "warning";
    };
    $[1] = action;
    $[2] = isProduction;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const getAlertVariant = t6;
  let t7;
  if ($[4] !== action || $[5] !== isProduction || $[6] !== t) {
    t7 = () => {
      if (action === "draft") {
        return t(_temp);
      }
      if (action === "deploy") {
        return t(_temp2);
      }
      if (isProduction) {
        return t(_temp3);
      }
      return t(_temp4);
    };
    $[4] = action;
    $[5] = isProduction;
    $[6] = t;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const getAlertText = t7;
  let t8;
  if ($[8] !== formMethods || $[9] !== onSubmit) {
    t8 = formMethods.handleSubmit(onSubmit);
    $[8] = formMethods;
    $[9] = onSubmit;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== getAlertText || $[12] !== getAlertVariant || $[13] !== hideAlert) {
    t9 = !hideAlert && <InlineAlert variant={getAlertVariant()}>{getAlertText()}</InlineAlert>;
    $[11] = getAlertText;
    $[12] = getAlertVariant;
    $[13] = hideAlert;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t(_temp5);
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t(_temp6);
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t) {
    t12 = t(_temp7);
    $[19] = t;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = {
      required: t12
    };
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t13) {
    t14 = <Form.Textarea size="compact" name="versionDescription" label={t10} placeholder={t11} rules={t13} rows={3} />;
    $[23] = t10;
    $[24] = t11;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t9) {
    t15 = <div className="flex flex-col gap-4">{t9}{t14}</div>;
    $[27] = t14;
    $[28] = t9;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== errors || $[31] !== graphHasErrors || $[32] !== register || $[33] !== user?.isCxOpsEmployee || $[34] !== user?.isRiskOpsEmployee) {
    t16 = graphHasErrors && (user?.isRiskOpsEmployee || user?.isCxOpsEmployee) && <Checkbox label="Save graph with errors (Employees only)" hasError={!!errors.skipValidation} hint={errors.skipValidation?.message} {...register("skipValidation", {
      required: "This graph has errors. You must select this option to save."
    })} />;
    $[30] = errors;
    $[31] = graphHasErrors;
    $[32] = register;
    $[33] = user?.isCxOpsEmployee;
    $[34] = user?.isRiskOpsEmployee;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15 || $[37] !== t16 || $[38] !== t8) {
    t17 = <form id="version-confirmation-form" onSubmit={t8}>{t15}{t16}</form>;
    $[36] = t15;
    $[37] = t16;
    $[38] = t8;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== formMethods || $[41] !== t17) {
    t18 = <FormProvider {...formMethods}>{t17}</FormProvider>;
    $[40] = formMethods;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
};
export default VersionForm;
function _temp($) {
  return $.versionDialog.draftAlert;
}
function _temp2($_0) {
  return $_0.versionDialog.deployAlert;
}
function _temp3($_1) {
  return $_1.versionDialog.publishProdAlert;
}
function _temp4($_2) {
  return $_2.versionDialog.publishAlert;
}
function _temp5($_3) {
  return $_3.versionDialog.description;
}
function _temp6($_4) {
  return $_4.versionDialog.versionDescriptionPlaceholder;
}
function _temp7($_5) {
  return $_5.versionDialog.versionDescriptionRequired;
}